import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./modal.css";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Badge from "@mui/material/Badge";
import { Button } from "react-bootstrap";
import TableSmall from "../../Theme/TableSmall.js";
import AddAgent from "./AddAgent";
import EditAgent from "./EditAgent";
import DeleteConfirmation from "../../deleteConfirmation";

const SubAgent = () => {
  const edit = "agentDetails";
  const detail = "driver-by-sub-agent";
  const agentParamId = useParams();
  const [id, setId] = useState(null);
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const [data, setData] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [agents, setAgents] = useState([]);

  const showEditModal = (id) => {
    setId(id);
    axios.get("/sub-agent/" + id, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
      },
    })
    .then((res) => {
      setData(res.data.subAgent);
      setDisplayEditModal(true);
    });
  };

  const showDeleteModal = (id) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this sub-agent`);
    setDisplayConfirmationModal(true);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Sub Agent Information",
        columns: [
          { Header: "ID", accessor: "id", disableFilters: true },
          { Header: "Name", accessor: "name", disableFilters: true },
          { Header: "Phone", accessor: "phone", disableFilters: true },
          { Header: "Email", accessor: "email", disableFilters: true },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,
            Cell: (row) => (
              <Badge
                badgeContent={row.cell.row.original.status}
                color={row.cell.row.original.status === "Active" ? "success" : "warning"}
              />
            ),
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div style={{ display: "flex", gap: "10px" }}>
                <Link to="" onClick={() => showEditModal(row.cell.row.original.id)}>
                  <i className="fas fa-edit info" />
                </Link>
                <Link to="" onClick={() => showDeleteModal(row.cell.row.original.id)}>
                  <i className="fas fa-trash error" />
                </Link>
                <Link to={`/${detail}/${row.cell.row.original.id}`}>
                  <i className="fas fa-eye success" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const notify = () => toast.success("Agent list loaded.");

  useEffect(() => {
    getAgents();
  }, []);

  const getAgents = async () => {
    let user = JSON.parse(localStorage.getItem("userData"));
    const response = await axios.get("sub-agents/" + user.id);
    setAgents(response.data);
    notify();
  };

  const submitDelete = (id) => {
    deleteAgent(id);
    setDisplayConfirmationModal(false);
  };

  const deleteAgent = async (id) => {
    await axios.delete("/sub-agent/" + id, { data: { id: id } });
    getAgents();
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  return (
    <div style={{ marginLeft: "0px" }}> {/* Aligning to the left */}
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Sub Agents</h3>
            <Button onClick={() => setDisplayAddModal(true)} className="btn btn-success bt">
              Add
            </Button>
          </div>

          <div className="card-body">
            <TableSmall
              columns={columns}
              data={agents}
              edit={edit}
              detail={detail}
            />
          </div>
        </div>
      </div>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      <AddAgent
        getAgents={getAgents}
        showModal={displayAddModal}
        hideModal={() => setDisplayAddModal(false)}
        agentId={agentParamId.id}
      />
      {displayEditModal && (
        <EditAgent
          getAgents={getAgents}
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={() => setDisplayEditModal(false)}
          agentId={agentParamId.id}
        />
      )}
    </div>
  );
};

export default SubAgent;